module.exports = __webpack_public_path__ + "static/24-f58ba8df56813bb71071c1547bb79b33.jpg";